(function () {
  'use strict';

  var script = document.currentScript;
  var config = {
    shop: script ? script.dataset.shop : '',
    lang: script ? script.dataset.lang : '',
    loggedIn: script ? script.dataset.loggedIn === 'true' : false,
    launch: script ? script.dataset.launch || '' : '',
    // 'mscore' or 'form', per shop from signup_mscore_shops in sale-settings.liquid.
    mscore: script ? script.dataset.signup === 'mscore' : false
  };

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var MARKETING_GROUP = 'C0004,';
  var DEFAULT_EVENT = 'newsletter_signup';
  var SDK_WAIT_MS = 10000;
  var SDK_POLL_MS = 500;
  var EMARSYS_FORM_URL = 'link.email.oneractive.com/u/register.php';
  // Emarsys fields never written into a tag or event: gender (inp_5) and the product variant (id, back-in-stock).
  var CHOICE_EXCLUDED = ['inp_5', 'id'];
  var MANUAL_WINDOW_MS = 3000;

  function slug(value) {
    return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  // --- Page the sign-up happens on -------------------------------------------------------------

  // Path without the locale prefix: /de/collections/shop/x → /collections/shop/x.
  function pagePath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = window.location.pathname;
    if (root !== '/' && (path + '/').indexOf(root) === 0) { path = path.slice(root.length - 1); }
    return path.replace(/\/+$/, '') || '/';
  }

  // Applied to every sign-up, whatever the form: the page type (placement) and the page's campaign, both from the
  // URL, so no form or page ever needs setup. Campaign is the last path segment — the same key sale-settings-enhanced-plp.liquid uses for PLPs
  // (/collections/shop/stories-of-strength → stories-of-strength), the article part for articles
  // (/blogs/news/cargos → cargos) — and on the homepage the current launch name from sale-settings.
  function currentPage() {
    var parts = pagePath().split('/').filter(Boolean);
    var last = parts[parts.length - 1];
    if (!parts.length) { return { type: 'hp', campaign: config.launch }; }
    switch (parts[0]) {
      case 'collections': return { type: 'plp', campaign: last };
      // A product is not a campaign; back-in-stock carries the product in its stock_notify event.
      case 'products': return { type: 'pdp', campaign: '' };
      case 'blogs': return { type: parts.length > 2 ? 'article' : 'blog', campaign: last };
      case 'pages': return { type: 'page', campaign: last };
      default: return { type: slug(parts[0]), campaign: last };
    }
  }

  // --- Shopify customer + email marketing consent ---------------------------------------------

  // UTC day of the sign-up, e.g. 20261027 — tags carry no timestamp of their own.
  function signupDate() {
    return new Date().toISOString().slice(0, 10).replace(/-/g, '');
  }

  // One tag per sign-up: src-<form>-<placement>--<campaign>[--<choice>]--<yyyymmdd>, e.g.
  // src-countdown-banner-hp--stories-of-strength--20261027 (campaign is left out when the page has none). slug() collapses everything inside a part to
  // single hyphens, so `--` only ever separates the parts and every Bloomreach segment is one `contains`
  // on `_tags` (source prefix, `--<campaign>--`, `--<yyyymm>`). Repeat sign-ups add a tag, never replace one.
  function buildTag(options) {
    var parts = [slug(options.source)];
    if (options.campaign) { parts.push(slug(options.campaign)); }
    if (options.choice) { parts.push(slug(options.choice)); }
    parts.push(signupDate());
    return 'src-' + parts.join('--');
  }

  // Through ms-core: Shopify's App Proxy forwards this, signed, to ms-core, which writes consent and the tag.
  // The root path reaches the proxy whatever the locale prefix.
  var MSCORE_SIGNUP_URL = '/apps/ms-core/signup';
  var MSCORE_TIMEOUT_MS = 4000;

  // 200 is a stored sign-up and 409 a store that is not live yet. Anything else rejects, and submit() logs
  // it. There is no fallback to the form.
  function subscribeMscore(options) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, MSCORE_TIMEOUT_MS) : null;
    return fetch(MSCORE_SIGNUP_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: options.email,
        first_name: options.firstName || '',
        last_name: options.lastName || '',
        tag: buildTag(options)
      }),
      keepalive: true, // Finishes even when the page is leaving.
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      clearTimeout(timer);
      if (response.status !== 200 && response.status !== 409) {
        throw new Error('ms-core answered ' + response.status);
      }
    }, function (error) {
      clearTimeout(timer);
      throw error;
    });
  }

  // Through the hidden customer form (snippets/signup-shopify-form.liquid), on shops not yet moved to ms-core.
  // Shopify only accepts customer forms with an hCaptcha token, and fills that token during a native
  // submit (Shopify.captcha.protect + form.submit). The form therefore posts natively into a hidden iframe:
  // Shopify gets its real submit, the page itself never navigates. Shopify answers with a redirect to
  // return_to (the empty templates/index.signup-frame.liquid), but its storefront pages refuse to be framed,
  // so the browser usually blocks that page and the frame becomes opaque.
  var FORM_TIMEOUT_MS = 10000;
  var frameCount = 0;

  function setField(form, name, value) {
    var input = form.elements[name];
    input.value = value || '';
    input.disabled = !value; // Never send an empty name over an existing customer's one.
  }

  function createFrame() {
    var frame = document.createElement('iframe');
    frame.name = 'oa-signup-frame-' + (++frameCount);
    frame.title = 'Sign-up';
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(frame);
    return frame;
  }

  // URL of the frame's document, or null when the browser blocked the framed page (opaque error document).
  function frameUrl(frame) {
    try {
      return frame.contentWindow.location.href;
    } catch (e) {
      return null;
    }
  }

  // Opaque frame: Shopify answered but refused to be framed, so the outcome can't be read. Readable frame:
  // success is the return_to page or ?customer_posted=true, a challenge or form error is reported.
  function frameResult(url) {
    if (url === null || url.indexOf('view=signup-frame') !== -1 || url.indexOf('customer_posted=true') !== -1) {
      return null;
    }
    return url.indexOf('/challenge') !== -1 ? 'captcha challenge' : 'not confirmed (' + url + ')';
  }

  function submitNatively(form) {
    var captcha = window.Shopify && window.Shopify.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(form, function () { form.submit(); });
    } else {
      form.submit(); // hCaptcha switched off for the store.
    }
  }

  function postShopifyForm(options) {
    var form = document.getElementById('oa-signup-shopify-form');
    if (!form) {
      return Promise.reject(new Error('shopify signup form not available'));
    }

    setField(form, 'contact[email]', options.email);
    setField(form, 'contact[first_name]', options.firstName);
    setField(form, 'contact[last_name]', options.lastName);
    setField(form, 'contact[tags]', buildTag(options));

    var frame = createFrame();
    form.target = frame.name;

    // Settles exactly once — on the frame's result or the timeout — and always removes the frame, so a
    // sign-up that never gets an answer (e.g. hCaptcha never ready) can't block the ones queued after it.
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        finish(new Error('timed out after ' + FORM_TIMEOUT_MS + 'ms'));
      }, FORM_TIMEOUT_MS);

      function onLoad() {
        var url = frameUrl(frame);
        if (url === 'about:blank') { return; } // Initial empty document.
        var error = frameResult(url);
        finish(error ? new Error(error) : null);
      }

      function finish(error) {
        clearTimeout(timer);
        frame.removeEventListener('load', onLoad);
        if (frame.parentNode) { frame.parentNode.removeChild(frame); }
        if (error) { reject(error); } else { resolve(); }
      }

      frame.addEventListener('load', onLoad);
      submitNatively(form);
    });
  }

  // One shared form, so sign-ups are posted one after another.
  var formQueue = Promise.resolve();

  function subscribeForm(options) {
    var run = formQueue.then(function () { return postShopifyForm(options); });
    formQueue = run.catch(function () {});
    return run;
  }

  // --- Marketing cookie consent (OneTrust C0004, mirrored into Shopify customerPrivacy) ---------

  function marketingAllowed() {
    if (typeof window.OnetrustActiveGroups === 'string') {
      return window.OnetrustActiveGroups.indexOf(MARKETING_GROUP) !== -1;
    }
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
  }

  function canOpenCookieSettings() {
    return !!(window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function');
  }

  // --- Bloomreach SDK event ---------------------------------------------------------------------

  function sdkReady() {
    return !!(window.brweb && typeof window.brweb.track === 'function');
  }

  function sendEvent(event) {
    // Logged-in customers are identified by the app; identifying them with a typed email could merge profiles.
    if (!config.loggedIn && typeof window.brweb.identify === 'function') {
      window.brweb.identify({ email_id: event.email });
    }
    window.brweb.track(event.name, event.properties);
  }

  // The SDK may only load after consent is granted, so give it a moment before sending.
  function whenSdkReady(callback) {
    var waited = 0;
    (function poll() {
      if (sdkReady()) { return callback(); }
      waited += SDK_POLL_MS;
      if (waited <= SDK_WAIT_MS) { setTimeout(poll, SDK_POLL_MS); }
    })();
  }

  // --- Marketing consent gate + inline notice ---------------------------------------------------

  // At most one form waits for consent at a time; resolve(true) once granted, resolve(false) when
  // declined, cancelled or replaced by a newer request.
  var waiting = null;

  function clearNotices() {
    Array.prototype.forEach.call(document.querySelectorAll('.oa-signup-notice'), function (notice) {
      notice.parentNode.removeChild(notice);
    });
  }

  function settle(granted) {
    var current = waiting;
    waiting = null;
    clearNotices();
    if (current) { current(granted); }
  }

  // Cloned from the template in snippets/signup-cookie-notice.liquid into the form's [data-signup-notice] slot.
  function renderNotice(slot, variant) {
    var template = document.getElementById('oa-signup-cookie-notice-template');
    if (!slot || !template) { return; }

    var notice = template.content.firstElementChild.cloneNode(true);
    notice.setAttribute('data-variant', variant || 'default');

    var settings = notice.querySelector('[data-signup-notice-settings]');
    settings.hidden = !canOpenCookieSettings();
    settings.addEventListener('click', function () {
      if (canOpenCookieSettings()) { window.OneTrust.ToggleInfoDisplay(); }
    });
    notice.querySelector('[data-signup-notice-dismiss]').addEventListener('click', function () {
      settle(false);
    });

    slot.innerHTML = '';
    slot.appendChild(notice);
  }

  /**
   * Resolves true right away when marketing cookies are allowed. Otherwise shows the inline notice in
   * `slot` and resolves true once the visitor accepts them, false on "No, thanks" or cancel.
   * @param {Element} slot      The form's [data-signup-notice] element
   * @param {string} [variant] Notice copy: 'default' or 'back-in-stock'
   * @returns {Promise<boolean>}
   */
  function requireMarketingConsent(slot, variant) {
    if (marketingAllowed()) { return Promise.resolve(true); }

    settle(false); // A newer request replaces an unanswered one.
    return new Promise(function (resolve) {
      waiting = resolve;
      renderNotice(slot, variant);
    });
  }

  /** Drops an unanswered request, e.g. when its form is closed. */
  function cancelMarketingConsent() {
    settle(false);
  }

  function onConsentChange() {
    if (waiting && marketingAllowed()) { settle(true); }
  }

  // --- Public API -------------------------------------------------------------------------------

  /**
   * Writes the sign-up to Shopify (consent, name, tag) through ms-core or the hidden form, and sends the Bloomreach event. Call it only
   * after requireMarketingConsent resolved true.
   * @param {Object} options
   * @param {string} options.email
   * @param {string} options.source      Form name, e.g. 'footer'. Placement and campaign are added from the page:
   *                                     src-footer-plp--stories-of-strength--20261027
   * @param {string} [options.firstName]
   * @param {string} [options.lastName]
   * @param {Object} [options.fields]    Extra form fields, Bloomreach event only (e.g. phone, country)
   * @param {string} [options.event]     Bloomreach event name, defaults to newsletter_signup
   * @param {Object} [options.properties] Extra event properties, e.g. product data for stock_notify
   * @param {string} [options.choice]     Option picked in the form (e.g. event city) → part of the tag + event property
   * @returns {Promise<void>} Settles once Shopify has answered (max 4s through ms-core, 10s through the form); never rejects.
   */
  function submit(options) {
    options = options || {};
    var email = String(options.email || '').trim();

    if (!EMAIL_PATTERN.test(email) || !options.source) {
      console.warn('[signup] skipped: valid email and source are required');
      return Promise.resolve();
    }

    recentSignups[email.toLowerCase()] = Date.now();

    var page = currentPage();
    var source = slug(options.source) + '-' + page.type;
    var campaign = page.campaign;

    var properties = Object.assign({
      source: source,
      campaign: campaign || null,
      choice: options.choice || null,
      shop: config.shop,
      language: config.lang
    }, options.fields || {}, options.properties || {});

    var event = {
      email: email,
      name: options.event || DEFAULT_EVENT,
      properties: Object.assign({ signed_up_at: new Date().toISOString() }, properties)
    };

    if (marketingAllowed()) {
      whenSdkReady(function () {
        try {
          sendEvent(event);
        } catch (e) {
          console.warn('[signup] bloomreach event failed', e);
        }
      });
    }

    var shopify = (config.mscore ? subscribeMscore : subscribeForm)({
      email: email,
      firstName: options.firstName,
      lastName: options.lastName,
      source: source,
      campaign: campaign,
      choice: options.choice
    });

    return shopify.catch(function (error) {
      console.warn('[signup] shopify consent failed: ' + error.message);
    });
  }

  // --- Every Emarsys form, without touching it ----------------------------------------------------

  // Forms that call submit() themselves are recorded here, so the automatic sync below skips them.
  var recentSignups = {};

  function signedUpManually(email) {
    var at = recentSignups[email.toLowerCase()];
    return !!at && Date.now() - at < MANUAL_WINDOW_MS;
  }

  function fieldValue(form, name) {
    var values = Array.prototype.map.call(form.querySelectorAll('[name="' + name + '"]'), function (field) {
      return String(field.value || '').trim();
    });
    return values.filter(Boolean).pop() || '';
  }

  // Sign-up from a native Emarsys form (<form action="…register.php">), read straight from its fields: email,
  // name, the option picked in a <select> (e.g. Walk Club city) and phone / birth date for the event. Only with
  // the marketing checkbox ticked, where the form has one.
  function syncEmarsysForm(form) {
    var email = fieldValue(form, 'inp_3');
    if (!email || signedUpManually(email)) { return Promise.resolve(); }

    var checkbox = form.querySelector('[name="accepts_marketing"]');
    if (checkbox && !checkbox.checked) { return Promise.resolve(); }

    var choice = Array.prototype.filter.call(form.querySelectorAll('select[name]'), function (select) {
      return CHOICE_EXCLUDED.indexOf(select.name) === -1 && select.value;
    }).map(function (select) { return select.value; }).join(' ');

    return submit({
      email: email,
      firstName: fieldValue(form, 'inp_1'),
      lastName: fieldValue(form, 'inp_2'),
      source: 'signup',
      choice: choice,
      fields: { phone: fieldValue(form, 'inp_15') || null, birth_date: fieldValue(form, 'inp_4') || null }
    });
  }

  // A sign-up form is an Emarsys form that opts in (optin=y). Profile, withdrawal and back-in-stock forms don't.
  function isEmarsysSignupForm(form) {
    return form instanceof HTMLFormElement
      && String(form.getAttribute('action') || '').indexOf(EMARSYS_FORM_URL) !== -1
      && fieldValue(form, 'optin') === 'y';
  }

  function emarsysFormFor(email) {
    var forms = document.querySelectorAll('form[action*="' + EMARSYS_FORM_URL + '"]');
    return Array.prototype.filter.call(forms, function (form) {
      return isEmarsysSignupForm(form) && fieldValue(form, 'inp_3').toLowerCase() === email.toLowerCase();
    })[0] || null;
  }

  // True when submitting replaces the current page, which could cancel the Shopify write.
  function leavesPage(form) {
    var target = form.getAttribute('target') || '';
    return !target || target === '_self' || target === '_top' || target === '_parent';
  }

  // Forms send to Emarsys in one of three ways; each is caught at the moment of sending, nothing runs before.
  // 1. axios.get(register.php): the Emarsys response is held until Shopify has answered, so forms that reload
  //    the page right after (most event articles) can't cancel the sign-up.
  function hookAxios() {
    if (!window.axios || !window.axios.interceptors) { return; }

    window.axios.interceptors.request.use(function (request) {
      var email = String((request.params && request.params.inp_3) || '').trim();
      if (String(request.url || '').indexOf(EMARSYS_FORM_URL) !== -1 && email) {
        var form = emarsysFormFor(email);
        request.oaSignup = form ? syncEmarsysForm(form) : null;
      }
      return request;
    });

    function afterSignup(request) {
      return (request && request.oaSignup) || Promise.resolve();
    }
    window.axios.interceptors.response.use(function (response) {
      return afterSignup(response.config).then(function () { return response; });
    }, function (error) {
      return afterSignup(error && error.config).then(function () { throw error; });
    });
  }

  // 2. form.submit() and 3. a plain submit (button, no JS). A form that posts into an iframe or a new tab
  //    keeps the page, so the sync runs alongside (one tick later, so forms that call oaSignup.submit() first
  //    are skipped). A form that replaces the page waits for Shopify (max. MSCORE_TIMEOUT_MS / FORM_TIMEOUT_MS),
  //    then goes on.
  var nativeSubmit = HTMLFormElement.prototype.submit;

  function sendEmarsysForm(form) {
    if (!leavesPage(form)) {
      setTimeout(function () { syncEmarsysForm(form); }, 0);
      return false;
    }
    syncEmarsysForm(form).then(function () { nativeSubmit.call(form); });
    return true;
  }

  function hookFormSubmit() {
    HTMLFormElement.prototype.submit = function () {
      if (isEmarsysSignupForm(this) && sendEmarsysForm(this)) { return; }
      return nativeSubmit.apply(this, arguments);
    };

    // Listens on window, so it runs after every handler of the form and the document: a form whose own
    // handler cancels the submit (validation, unticked checkbox, axios forms) is left alone.
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (event.defaultPrevented || !isEmarsysSignupForm(form)) { return; }
      if (sendEmarsysForm(form)) { event.preventDefault(); }
    });
  }

  window.oaSignup = {
    submit: submit,
    requireMarketingConsent: requireMarketingConsent,
    cancelMarketingConsent: cancelMarketingConsent
  };

  hookAxios();
  hookFormSubmit();

  // OneTrust and Shopify each announce consent changes; either one may release a waiting form.
  window.addEventListener('OneTrustGroupsUpdated', onConsentChange);
  document.addEventListener('visitorConsentCollected', onConsentChange);
})();
